export default {
      id: "sli-copy-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-copy",
      toString: function () {
        return this.url;
      }
    }